export const songVideoStyles = {
  embeddedPlayer: {
    paddingBottom: 10,
    paddingTop: 10,
  },
};
